import { render, staticRenderFns } from "./CreateBiz.vue?vue&type=template&id=a3a7c502&lang=pug"
import script from "./CreateBiz.vue?vue&type=script&lang=js"
export * from "./CreateBiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports